export const FORGET_PASSWORD = "FORGET_PASSWORD";
export const FORGET_PASSWORD_SUCCESS = "FORGET_PASSWORD_SUCCESS";
export const FORGET_PASSWORD_ERROR = "FORGET_PASSWORD_ERROR";

export const STAFF_FORGET_PASSWORD = "STAFF_FORGET_PASSWORD";
export const STAFF_FORGET_PASSWORD_SUCCESS = "STAFF_FORGET_PASSWORD_SUCCESS";
export const STAFF_FORGET_PASSWORD_ERROR = "STAFF_FORGET_PASSWORD_ERROR";

export const OTP_FORGET_PASSWORD = "OTP_FORGET_PASSWORD";
export const OTP_FORGET_PASSWORD_SUCCESS = "OTP_FORGET_PASSWORD_SUCCESS";
export const OTP_FORGET_PASSWORD_ERROR = "OTP_FORGET_PASSWORD_ERROR";

export const STAFF_OTP_FORGET_PASSWORD = "STAFF_OTP_FORGET_PASSWORD";
export const STAFF_OTP_FORGET_PASSWORD_SUCCESS = "STAFF_OTP_FORGET_PASSWORD_SUCCESS";
export const STAFF_OTP_FORGET_PASSWORD_ERROR = "STAFF_OTP_FORGET_PASSWORD_ERROR";
